<template>
    <div>
      <CRow>
        <CCol sm="12" md="12">
          <CCard accent-color="primary">
            <CCardHeader
              class="font-weight-bold padding-sm d-flex justify-content-between catalogo-text"
            >
              <CRow style="width:100%">
                <CCol md="4" lg="4" xl="4"> Historial de prestaciones </CCol>
                <CCol md="8" lg="8" xl="8">



                </CCol>
              </CRow>
            </CCardHeader>
            <CCardBody>
              <CRow>
                <CCol md="6" lg="6" xl="4">
                  <label class="d-block">Periodo:</label>
                  <DateSelector
                    class="z-custom-2 mb-2"
                    v-model="selectedDate"
                    :date="selectedDate"
                    @input="dateSelection()"
                  />
                </CCol>
              </CRow>

              <CDataTable
                hover
                bordered
                small
                fixed
                :loading="isLoading"
                :items="agrupar ? rowCItems : items"
                :fields="headersTable"
                :items-per-page="Number(limit)"
                :noItemsView="noItems"
              >
                <template #over-table>
                  <CRow class="">
                    <CCol v-if="advanceFilter" sm="11" col="10">
                      <CRow class="advance-filter mb-4">
                        <CCol md="6">
                          <label class="d-block">Trabajador:</label>
                          <div class="d-flex margin-multi align-items-center">
                            <MultiSelectC
                              v-model="query.trabajadores"
                              :options="trabajadores"
                              :multiple="true"
                              :loading="isLoadingInfo"
                              label="label"
                              track-by="label"
                              placeholder="Trabajadores"
                              :close-on-select="false"
                              :clear-on-select="false"
                            >
                              <template #no-options>Sin resultados.</template>
                            </MultiSelectC>
                            <transition name="fade">
                              <div
                                v-show="
                                  query.trabajadores && query.trabajadores.length
                                "
                                @click="
                                  () => {
                                    query.trabajadores = [];
                                  }
                                "
                              >
                                <CIcon
                                  size="lg"
                                  class="ml-2 cursor-p"
                                  name="cil-trash"
                                />
                              </div>
                            </transition>
                          </div>
                        </CCol>
                        <CCol md="6" v-if="showUbicaciones">
                          <label class="d-block">Ubicaciones:</label>
                          <div class="d-flex margin-multi align-items-center">
                            <MultiSelectC
                              v-model="query.ubicaciones"
                              :options="ubicaciones"
                              :multiple="true"
                              :loading="isLoadingInfo"
                              label="label"
                              track-by="label"
                              placeholder="Ubicaciones"
                              :close-on-select="false"
                              :clear-on-select="false"
                            >
                              <template #no-options>Sin resultados.</template>
                            </MultiSelectC>
                            <transition name="fade">
                              <div
                                v-show="
                                  query.ubicaciones && query.ubicaciones.length
                                "
                                @click="
                                  () => {
                                    query.ubicaciones = [];
                                  }
                                "
                              >
                                <CIcon
                                  size="lg"
                                  class="ml-2 cursor-p"
                                  name="cil-trash"
                                />
                              </div>
                            </transition>
                          </div>
                        </CCol>
                        <CCol md="6">
                          <label class="d-block">Actividad:</label>
                          <div class="d-flex margin-multi align-items-center">
                            <MultiSelectC
                              v-model="query.actividades"
                              :options="actividades"
                              :multiple="true"
                              :loading="isLoadingInfo"
                              label="label"
                              track-by="label"
                              placeholder="Actividades"
                              :close-on-select="false"
                              :clear-on-select="false"
                            >
                              <template #no-options>Sin resultados.</template>
                            </MultiSelectC>
                            <transition name="fade">
                              <div
                                v-show="
                                  query.actividades && query.actividades.length
                                "
                                @click="
                                  () => {
                                    query.actividades = [];
                                  }
                                "
                              >
                                <CIcon
                                  size="lg"
                                  class="ml-2 cursor-p"
                                  name="cil-trash"
                                />
                              </div>
                            </transition>
                          </div>
                        </CCol>
                        <CCol md="6">
                          <label class="d-block">Cantidad Costo:</label>
                          <CRow>
                            <CCol
                              ><CInput
                                type="number"
                                :value.sync="$v.query.cantidad_costo.start.$model"
                                placeholder="De"
                                class="mb-0 align-self-center"
                                :isValid="query_cantidad_costo_start"
                            /></CCol>
                            <CCol
                              ><CInput
                                type="number"
                                :value.sync="$v.query.cantidad_costo.end.$model"
                                placeholder="Al"
                                class="mb-0 align-self-center"
                                :isValid="query_cantidad_costo_end"
                            /></CCol>
                          </CRow>
                        </CCol>
                        <CCol md="6">
                          <label class="d-block">Costo Unitario:</label>
                          <CRow>
                            <CCol
                              ><CInput
                                type="number"
                                :value.sync="$v.query.costo_unitario.start.$model"
                                placeholder="De"
                                class="mb-0 align-self-center"
                                :isValid="query_costo_unitario_start"
                            /></CCol>
                            <CCol
                              ><CInput
                                type="number"
                                :value.sync="$v.query.costo_unitario.end.$model"
                                placeholder="Al"
                                class="mb-0 align-self-center"
                                :isValid="query_costo_unitario_end"
                            /></CCol>
                          </CRow>
                        </CCol>
                        <CCol md="6">
                          <label class="d-block">Comentarios:</label>
                          <CInput
                            v-model="query.comentarios"
                            placeholder="Comentarios"
                            class="mb-0 align-self-center"
                          />
                        </CCol>
                        <CCol col="10" class="pt-3">
                          <CButton @click="validForm" color="primary">
                            Buscar</CButton
                          >
                        </CCol>
                      </CRow>
                    </CCol>
                    <CCol v-else sm="11" col="10">
                      <CInput
                        v-model="filter"
                        @input="searchTimeOut()"
                        placeholder="Búsqueda..."
                      />
                    </CCol>
                    <CCol class="p-0" sm="1" col="2">
                      <CDropdown
                        placement="bottom-start"
                        add-menu-classes="pt-0"
                        color="primary"
                        :show.sync="dropdownCustom"
                      >
                        <template #toggler>
                          <CButton color="secondary">
                            <CIcon name="cil-settings" />
                          </CButton>
                        </template>

                        <template #default>
                          <div class="p-3 d-flex flex-column w-100">
                            <div class="mb-1">
                              <span>
                                <strong>Ver</strong>
                              </span>
                            </div>
                            <hr class="line mt-1 mb-3" />
                            <div
                              class="d-flex align-items-center justify-content-between mb-2"
                            >
                              <label class="mr-2"
                                >Agrupar activivad por trabajador:</label
                              >
                              <CSwitch
                                :checked="agrupar"
                                @update:checked="toggleAgrupar()"
                                class="mx-1"
                                color="primary"
                                variant="3d"
                              />
                            </div>

                            <div
                              class="d-flex align-items-center justify-content-between mb-2"
                            >
                              <label class="mr-2">Busqueda avanzada:</label>
                              <CSwitch
                                :checked="advanceFilter"
                                @update:checked="toggleAdvanceFilter()"
                                class="mx-1"
                                color="primary"
                                variant="3d"
                              />
                            </div>

                            <div
                              class="d-flex align-items-center justify-content-between mb-2"
                            >
                              <label class="mr-2">Hora:</label>
                              <CSwitch
                                @update:checked="toggleHora()"
                                class="mx-1"
                                color="primary"
                                variant="3d"
                              />
                            </div>

                            <div
                              class="d-flex align-items-center justify-content-between mb-2"
                            >
                              <label class="mr-2">Fecha de creación:</label>
                              <CSwitch
                                @update:checked="toggleCreatedAt()"
                                class="mx-1"
                                color="primary"
                                variant="3d"
                              />
                            </div>

                            <div
                              class="d-flex align-items-center justify-content-between mb-2"
                            >
                              <label class="mr-2">Ubicaciones:</label>
                              <CSwitch
                                @update:checked="toggleUbicaciones()"
                                class="mx-1"
                                color="primary"
                                variant="3d"
                              />
                            </div>

                            <div
                              class="d-flex align-items-center justify-content-between mb-2"
                            >
                              <label class="mr-2">Autor:</label>
                              <CSwitch
                                @update:checked="toggleMostrarAutor()"
                                class="mx-1"
                                color="primary"
                                variant="3d"
                              />
                            </div>

                            <div
                              class="d-flex align-items-center justify-content-between mb-2"
                            >
                              <label class="mr-2">Cancelados:</label>
                              <CSwitch
                                @update:checked="toggleShowCancel()"
                                class="mx-1"
                                color="primary"
                                variant="3d"
                              />
                            </div>
                          </div>
                        </template>
                      </CDropdown>
                    </CCol>

                  </CRow>
                </template>

                <template #check-header>
                  <div class="d-flex flex-row" v-if="items.length">
                    <input
                      id="all"
                      type="checkbox"
                      @input="checkAll"
                      :checked="_prestacionesCheck_"
                      class="ml-3"
                    />
                  </div>
                </template>
                <template #check="{item}">
                  <td class="py-2" :class="item.className || ''">
                    <input
                      v-if="item.children"
                      :id="item.sku"
                      type="checkbox"
                      @input="checkSku($event, item)"
                      :checked="_prestacionesCheckSku_[item.sku]"
                      class="ml-3"
                    />
                    <input
                      v-else
                      v-model="prestacionesCheck[item.folio]"
                      type="checkbox"
                      class="form-check-input ml-3"
                    />
                  </td>
                </template>
                <template #folio-header>
                  <div class="d-flex flex-row">
                    <span class="align-self-center">Folio</span>
                    <OrderButtons
                      :onClick="sortField"
                      :field="'doc_prestaciones.folio'"
                      :order="false"
                      :fila="actualSort"
                      :direcction="sorting"
                    />
                  </div>
                </template>
                <template #fechahora-header>
                  <div class="d-flex flex-row">
                    <span class="align-self-center">Fecha</span>
                    <OrderButtons
                      :onClick="sortField"
                      :field="'doc_prestaciones.payload->encabezado->fechahora'"
                      :order="false"
                      :fila="actualSort"
                      :direcction="sorting"
                    />
                  </div>
                </template>
                <template #trabajador_id-header>
                  <div class="d-flex flex-row">
                    <span class="align-self-center">Trabajador</span>
                    <OrderButtons
                      :onClick="sortField"
                      :field="'trabajador.payload->nombre'"
                      :order="true"
                      :fila="actualSortJoin"
                      :direcction="sortingJoin"
                    />
                  </div>
                </template>
                <template #actividad_id-header>
                  <div class="d-flex flex-row">
                    <span class="align-self-center">Actividad</span>
                    <OrderButtons
                      :onClick="sortField"
                      :field="'actividad.payload->nombre'"
                      :order="true"
                      :fila="actualSortJoin"
                      :direcction="sortingJoin"
                    />
                  </div>
                </template>
                <template #folio="{item}">
                  <td class="py-2" :class="item.className || ''">
                    <template v-if="!item.children">
                      {{ item.folio }}
                    </template>
                    <template v-else>
                      <CButton
                        color="info"
                        square
                        size="sm"
                        @click="_ => toggleCollapse(item.sku)"
                      >
                        <i
                          :class="
                            `fa fa-angle-${
                              collapseItem[item.sku] ? 'up' : 'down'
                            }`
                          "
                        ></i>
                      </CButton>
                    </template>
                  </td>
                </template>
                <template #fechahora="{item}">
                  <td class="py-2" :class="item.className || ''">
                    {{ getDate(item.payload.encabezado.fechahora) }}
                  </td>
                </template>
                <template #estado="{item}">
                  <td class="py-2" :class="item.className || ''">
                    {{ item.estado }}
                  </td>
                </template>
                <template #trabajador_id="{item}">
                  <td class="py-2" :class="item.className || ''">
                    {{ validarTrabajador(item.payload.encabezado) }}
                  </td>
                </template>
                <template #actividad_id="{item}">
                  <td class="py-2" :class="item.className || ''">
                    {{ validarActividad(item.payload.encabezado) }}
                  </td>
                </template>
                <template #ubicaciones="{item}">
                  <td class="py-2" :class="item.className || ''">
                    {{ validarUbicaciones(item.payload.encabezado) }}
                  </td>
                  <!-- <td class="py-2">{{ item.payload.encabezado._relaciones.ubicacion_raiz.payload.nombre }}</td> -->
                </template>
                <template #cantidad_costo="{item}">
                  <td class="py-2 text-right" :class="item.className || ''">
                    {{
                      $formatter(
                        agrupar
                          ? item.getCantidadCosto()
                          : item.payload.encabezado.cantidad_costo,
                        0,
                        ".00"
                      )
                    }}
                  </td>
                </template>
                <template #costo_unitario="{item}">
                  <td class="py-2 text-right" :class="item.className || ''">
                    {{
                      agrupar
                        ? item.getCostoUnitario
                            .map(m => $formatter(m, 1))
                            .join(", ")
                        : $formatter(item.payload.encabezado.costo_unitario, 1)
                    }}
                  </td>
                </template>
                <template #costo_total="{item}">
                  <td class="py-2 text-right" :class="item.className || ''">
                    {{
                      $formatter(
                        agrupar
                          ? Number(item.getCostoTotal())
                          : Number(item.payload.encabezado.cantidad_costo) *
                              Number(item.payload.encabezado.costo_unitario),
                        1
                      )
                    }}
                  </td>
                </template>
                <template #autor-header>
                  <div class="d-flex flex-row">
                    <span v-show="mostrarColumnaAutor">Autor</span>
                  </div>
                </template>
                <template #autor="{item}">
                  <td class="py-2" :class="item.className || ''">
                    <span v-show="mostrarColumnaAutor">{{
                      item.author.correo
                    }}</span>
                  </td>
                </template>
                <template #hour-header>
                  <div class="d-flex flex-row">
                    <span v-show="showHora">Hora</span>
                  </div>
                </template>
                <template #hour="{item}">
                  <td class="py-2" :class="item.className || ''">
                    <span v-show="showHora">{{
                      getHour(item.payload.encabezado.fechahora)
                    }}</span>
                  </td>
                </template>
                <template #created_at-header>
                  <div class="d-flex flex-row">
                    <span v-show="showCratedAt">Fecha de creación</span>
                  </div>
                </template>
                <template #created_at="{item}">
                  <td class="py-2" :class="item.className || ''">
                    <span v-show="showCratedAt">{{
                      getFullDate(item.created_at)
                    }}</span>
                  </td>
                </template>
                <template #ver="{item}">
                  <td class="py-2" :class="item.className || ''">
                    <router-link
                      v-if="!item.children"
                      :to="{
                        name: 'VerPrestacion',
                        params: {
                          id: item.folio,
                          config: { page: page, dates: selectedDate }
                        }
                      }"
                    >
                      <CButton color="success" square size="sm">Ver</CButton>
                    </router-link>
                  </td>
                </template>
                 <!-- <template #reporte="{item, index}">
                  <td class="py-2" :class="item.className || ''">
                    <CButton
                      v-if="!item.children"
                      color="info"
                      square
                      size="sm"
                      @click="getReporte(index, item)"
                    >
                      <i v-if="loader[index]" class="fa fa-spinner fa-pulse"></i>
                      <template v-else>PDF</template>
                    </CButton>
                  </td>
                </template> -->
                <template #under-table>
                  <div class="footer-table">
                    <div
                      style="gap: 5px"
                      class="d-flex align-items-center justify-content-start"
                    >
                      Total {{ total }} ,
                      <CSelect
                        :value="limit"
                        label=""
                        invalidFeedback="Campo requerido, debe seleccionar una opción"
                        :options="[10, 25, 50, 100]"
                        @update:value="v => (limit = v)"
                        class="mb-0"
                      />{{ " " }}artículos / página
                    </div>
                    <CPagination
                      :activePage.sync="page"
                      :pages="pages"
                      align="center"
                      @update:activePage="e => actualizarInfo()"
                    />
                  </div>
                </template>
              </CDataTable>
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>

      <CModal
        :show.sync="showInfo"
        :no-close-on-backdrop="true"
        :centered="false"
        title="Funcionalidades del botón “Complementos de salario”"
        color="info"
        class="modal-content-info"
      >
      <div  style="text-align: justify">
        <ul>
          <li>
            <strong>Séptimo día</strong>
            <ul>
              <li>
                Proporcional al trabajo realizado en la semana.
                <ul>
                <li>6 días de 8 horas = 100% del séptimo día.</li>
                <li>Si se excede de 6 días de 8 horas solo se dará como 7mo día lo equivalente a un día de 8 horas.</li>
              </ul>
              </li>
            </ul>
          </li>
          <li>
            <strong>Prima dominical</strong>
            <ul>
              <li>Aplica solo el domingo y corresponde al 25% de lo realizado.</li>
            </ul>
          </li>
          <li>
            <strong>Día de descanso</strong>
            <ul>
              <li>Se genera cuando el trabajador va a trabajar en su día de descanso y contiene tal cual las actividades realizadas.</li>
              <li>
                Considerar el cambio de día de descanso basado en una falta de otro día.
                <ul>
                  <li>Ejemplo: si su día de descanso es el domingo, pero el trabajador si asiste a trabajar el domingo, pero falta el miércoles, el miércoles se convierte en su día de descanso (SOLO POR ESA SEMANA). Por lo cual el domingo (el cual normalmente es su día de descanso) No se le pagará su día de descanso (no se le pagará doble), sino que se le pagará como un día normal.</li>
                </ul>
              </li>
            </ul>
          </li>
          <li>
            <strong>Día festivo</strong>
            <ul>
              <li>Proporcional al trabajo realizado en la semana (configurar los días considerados como festivo por la empresa).</li>
            </ul>
          </li>
          <li>
            <strong>Condiciones y tabuladores personalizados</strong>
            <ul>
              <li>Preguntar por al equipo de HOOCH por las condiciones y tabuladores personalizados.</li>
            </ul>
          </li>
        </ul>
        <strong>Los complementos de salario deben ser solicitados primeramente al equipo de HOOCH para que sean configurados</strong>
      </div>
      <template #footer>
         <div></div>
      </template>

    </CModal>


      <ModalTable :datasheet="pagosDias" :show="showTablePagosDias" />

      <CModal
        size="sm"
        title="Reporte"
        :centered="true"
        color="warning"
        :show.sync="warningModal"
      >
        {{ error }}
      </CModal>
      <CModal
        :closeOnBackdrop="false"
        size="sm"
        :title="loadingModal || ''"
        :centered="true"
        color="info"
        :show.sync="_loadingModal"
      >
        <template #footer>
          <strong></strong>
        </template>
        <div class="w-100 d-flex justify-content-center">
          <div class="sk-flow align-items-center">
            <div class="sk-flow-dot bg-primary"></div>
            <div class="sk-flow-dot bg-primary"></div>
            <div class="sk-flow-dot bg-primary"></div>
          </div>
        </div>
      </CModal>
    </div>
  </template>

  <script>
  import moment from "moment";
  import DateSelector from "../../../customComponents/DateSelector";
  import ModalTable from "../../../customComponents/ModalTable";
  import OrderButtons from "../../../customComponents/OrderButtons";
  import GridAutorMixin from "../../../mixins/GridAutor";
  import Multiselect from "vue-multiselect";

  import { validationMixin } from "vuelidate";
  import "vue-select/dist/vue-select.css";



  const fields = [
    // { key: "check", label: "", _style: "width: 40px" },
    {
      key: "folio",
      label: "Folio",
      _style: "width: 70px"
    },
    // { key: "UBICACION_NOMBRE", label: "Ubicación", _style: "width:10%" },
    {
      key: "fechahora",
      label: "Fecha",
      _style: "min-width: 70px"
    },
    { key: "hour", label: "Hora", _style: "", },
    {
      key: "estado",
      label: "Estado",
      _style: ""
    },
    {
      key: "trabajador_id",
      label: "Trabajador",
      _style: ""
    },
    {
      key: "ubicaciones",
      label: "Ubicaciones",
      _style: ""
    },
    {
      key: "actividad_id",
      label: "Actividad",
      _style: ""
    },
    // { key: "UNIDAD", label: "Unidad", _style: "width:10%" },
    // { key: "cantidad", label: "Cantidad", _style: "width:10%" },
    {
      key: "cantidad_costo",
      label: "Cantidad Costo",
      _style: "max-width: 100px"
    },
    {
      key: "costo_unitario",
      label: "Costo Unitario",
      _style: "max-width: 100px"
    },
    {
      key: "costo_total",
      label: "Costo Total",
      _style: "max-width: 100px"
    },
    { key: "created_at", label: "Fecha de creación", _style: "" },
    {
      key: "autor",
      label: "",
      _style: ""
    },
      {
        key: "ver",
        label: "",
        _style: "width: 40px",
        sorter: false,
        filter: false
      },
    //   {
    //     key: "reporte",
    //     label: "",
    //     _style: "width: 40px",
    //     sorter: false,
    //     filter: false
    //   },
  ];

  export default {
    name: "Prestacion",
    components: {
      DateSelector,
      ModalTable,
      OrderButtons,
      'MultiSelectC': Multiselect,

    },
    mixins: [GridAutorMixin,validationMixin],
    validations: {
      query:{
        costo_unitario:{
          start:{
            maxValue: (v,costo_unitario)=>{
              return costo_unitario.start && costo_unitario.end ? Number(v) <= Number(costo_unitario.end) : true
            }
          },
          end:{
            minValue: (v,costo_unitario)=>{
              return costo_unitario.start && costo_unitario.end ? Number(v) >= Number(costo_unitario.start) : true
            }
          }
        },
        cantidad_costo:{
          start:{
            maxValue: (v,cantidad_costo)=>{
              return cantidad_costo.start && cantidad_costo.end ? Number(v) <= Number(cantidad_costo.end) : true
            }
          },
          end:{
            minValue: (v,cantidad_costo)=>{
              return cantidad_costo.start && cantidad_costo.end ? Number(v) >= Number(cantidad_costo.start) : true
            }
          }
        }
      }
    },
    data() {
      return {

        limit: 10,
        total: 0,
        prestacionesCheck: {},
        loadingModal: '',
        show: false,
        showInfo: false,
        query:{
          cantidad_costo:{start:'',end:''},
          costo_unitario:{start:'',end:''},
        },
        showHora: false,
        showCratedAt: false,
        advanceFilter: false,

        agrupar: false,
        collapseItem: {},
        items: [],
        fields,
        warningModal: false,
        error: "",
        prestaciones: [],
        config: this.$route.params.config,
        dropdownCustom: false,
        showCancel: false,
        isLoteActive: true,
        isCreated: false,
        color1: "primary",
        color2: "secondary",
        filter: "",
        noItems: {
          noResults: "Sin Resultados",
          noItems: "Sin Resultados"
        },
        ubicaciones: [],
        ubicaciones_principales: [],
        ubicacion_principal: 0,
        actualSort: "doc_prestaciones.payload->encabezado->fechahora",
        actualSortJoin: "",
        cambioUbicacionRaiz: false,
        // ubicacionesAll: [],
        // cultivos: [],
        // cultivosAll: [],
        // lotes: [],
        trabajadores: [],
        actividades: [],
        actividadesAll: [],
        empresa: "",
        trabajador: "",
        empresas: [],
        pagosDias: [],
        showTablePagosDias: false,

        // cultivo: null,
        // ubicacion: null,
        // lote: null,
        fechaCalcularPD: false,
        fechaCalcularPagoDias: {
          start: moment()
            .startOf("month")
            .toDate(),

          end: moment()
            .endOf("month")
            .toDate()
        },

        showUbicaciones: false,
        itemModal: {
          id: "",
          name: "",
          index: ""
        },
        isLoading: false,
        isLoadingInfo: false,
        alertError: false,
        message: "",
        page: 1,
        pages: 1,
        sorting: "desc",
        sortingJoin: "",
        selectedDate: {
          start: moment()
            .startOf("month")
            .toDate(),

          end: moment()
            .endOf("month")
            .toDate()
        },
        loader: {},

      };
    },

    created() {


      if (this.ubicacionRaiz == "") {
        this.items = [];
        return;
      }

      this.isCreated = false;

      this.page = this.config ? this.config.page : 1;
      this.selectedDate = this.config ? this.config.dates : this.selectedDate;

      this.$store.dispatch("customHTTP", {
          schema: "ubicaciones",
          filter: {
            where: [
              {
                field: "payload->suspendido",
                value: false,
                operator: "="
              }
            ]
          },
          order:[{
            field: 'payload->nombre',
            direction: 'asc'
          }]
        })
        .then(ubicaciones=>{
            this.ubicaciones = ubicaciones.data
        })

      this.$store.dispatch("customHTTP", {
          schema: "ubicaciones",
          filter:{
            "where": [
              {
                "field": "payload->pertenece_id",
                "operator": "=",
                "value": 0
              },
              {
                "field": "payload->suspendido",
                "operator": "=",
                "value": false
              }
            ]
          },
          order:[{
            field: 'payload->nombre',
            direction: 'asc'
          }]
        })
        .then(ubicaciones=>{
            this.ubicaciones_principales = ubicaciones.data.map(m=>({value:m.id,label:m.payload.nombre})).sort((a,b)=>a.label.localeCompare(b.label))
        })

      this.actualizarInfo(true);
    },

    computed: {
      query_filter(){
        return Object.keys(this.query).reduce((v,key)=>{
          if(key==='actividades'){
            const actividadesIds = this.query?.actividades?.map(m=>m.value)
            actividadesIds.length&&
              v.push({
                field: "doc_prestaciones.payload->encabezado->actividad_id",
                operator: "regexp",
                value: `[[:<:]](${actividadesIds.join('|')})[[:>:]]`
              })
          }
          if(key==='trabajadores'){
            const trabajadoresIds = this.query.trabajadores.map(m=>m.value)
            trabajadoresIds.length&&
              v.push({
                field: "doc_prestaciones.payload->encabezado->trabajador_id",
                operator: "regexp",
                value: `[[:<:]](${trabajadoresIds.join('|')})[[:>:]]`
              })
          }
          if(key==='ubicaciones'){
            const ubicacionesIds = this.query.ubicaciones.map(m=>m.value)
            this.showUbicaciones&&ubicacionesIds.length&&
              v.push({
                field: "doc_prestaciones.payload->encabezado->ubicaciones",
                operator: "regexp",
                value: `[[:<:]](${ubicacionesIds.join('|')})[[:>:]]`
              })
          }
          if(key==='comentarios'){
            this.query.comentarios&&
            v.push({
              field: "doc_prestaciones.payload->encabezado->comentarios",
              operator: "like",
              value: `%${this.query.comentarios}%`,
              collate: "utf8mb4_unicode_ci"
            })
          }
          if(key==='costo_unitario'){
            this.query.costo_unitario.start&&
            v.push({
              field: "doc_prestaciones.payload->encabezado->costo_unitario",
              operator: ">=",
              value: Number(this.query.costo_unitario.start),
            })
            this.query.costo_unitario.end&&
            v.push({
              field: "doc_prestaciones.payload->encabezado->costo_unitario",
              operator: "<=",
              value: Number(this.query.costo_unitario.end),
            })
          }
          if(key==='cantidad_costo'){
            this.query.cantidad_costo.start&&
            v.push({
              field: "doc_prestaciones.payload->encabezado->cantidad_costo",
              operator: ">=",
              value: Number(this.query.cantidad_costo.start),
            })
            this.query.cantidad_costo.end&&
            v.push({
              field: "doc_prestaciones.payload->encabezado->cantidad_costo",
              operator: "<=",
              value: Number(this.query.cantidad_costo.end),
            })
          }
          return v
        },[])
      },
      query_costo_unitario_start(){
        return this.$v.query.costo_unitario.start.$dirty?!this.$v.query.costo_unitario.start.$invalid:null
      },
      query_costo_unitario_end(){
        return this.$v.query.costo_unitario.end.$dirty?!this.$v.query.costo_unitario.end.$invalid:null
      },
      query_cantidad_costo_start(){
        return this.$v.query.cantidad_costo.start.$dirty?!this.$v.query.cantidad_costo.start.$invalid:null
      },
      query_cantidad_costo_end(){
        return this.$v.query.cantidad_costo.end.$dirty?!this.$v.query.cantidad_costo.end.$invalid:null
      },
      _loadingModal:{
        get(){
          return !!this.loadingModal
        },
        set(val){
          this.loadingModal = val||''
        }
      },
      _countSelected_(){
        return Object.keys(this.prestacionesCheck).reduce((v,key)=>this.prestacionesCheck[key]?v+1:v,0)
      },
      _prestacionesCheck_(){
        return Object.keys(this.prestacionesCheck).length&&this.items.map(m=>m.folio).every(key=>this.prestacionesCheck[key])
      },
      prestacionesIsSelected(){
        return Object.keys(this.prestacionesCheck).some(s=>this.prestacionesCheck[s])
      },
      prestacionesCheck_(){
        return Object.keys(this.prestacionesCheck).filter(ff=>this.prestacionesCheck[ff])
      },

      rangeStart() {
        return new Date(this.selectedDate.start).toLocaleDateString();
      },
      rangeEnd() {
        return new Date(this.selectedDate.end).toLocaleDateString();
      },
      headersTable() {
        return this.fields.filter(ff=>{
          if(
            (ff.key==='ubicaciones'&&!this.showUbicaciones) ||
            (ff.key==='hour'&&!this.showHora) ||
            (ff.key==='created_at'&&!this.showCratedAt) ||
            (ff.key==='autor'&&!this.mostrarColumnaAutor)
          ){
            return false
          }
          return true
        })
      },
      ubicacionRaiz() {
        return this.$store.state.rootLocation
          ? this.$store.state.rootLocation.value
          : "";
      },
      rowItems(){
        const getVal = function(key){
          return function() {
            if(!this.children){
              if(key==='costo_total'){
                return this.payload.encabezado.cantidad_costo * this.payload.encabezado.costo_unitario
              }
              return this.payload.encabezado[key]
            } else {
              const meth = {
                cantidad_costo:'getCantidadCosto',
                costo_total:'getCostoTotal',
              }
              const val = this.children.reduce((v,c)=>{
                return v+c[meth[key]]()
              },0)
              return val
            }
          }
        }

        return this.items.reduce((v,c)=>{
          const sku = `${moment(c.payload.encabezado.fechahora,'YYYY-MM-DD').format('YYYY-MM-DD')}-${c.payload.encabezado.trabajador_id}-${c.payload.encabezado.actividad_id}`
          const item = {
            ...c,
            sku,
            get getCantidadCosto(){return getVal('cantidad_costo')},
            get getCostoUnitario(){
              return this.children?[...new Set(this.children.map(m=>m.payload.encabezado.costo_unitario).sort((a,b)=>a-b))]:[this.payload.encabezado.costo_unitario]
            },
            get getCostoTotal(){return getVal('costo_total')},
            children: null,
          }

          const fond = v.find(f=>f.sku === sku)
          if(fond){
            if(fond.children){
              fond.children.push(item)
            } else {
              const {children, ...olItem} = fond
              children;
              fond.children = [olItem, item]
            }
          }
          else{
            v.push(item)
          }
          return v

        },[])
      },
      rowCItems(){
        return this.rowItems.reduce((v,c)=>{
          if(c.children){
            c.className = 'table-info'
          }
          v.push(c)
          if(this.collapseItem[c.sku]){
            v.push(...c.children.map(m=>({...m,className: 'table-info'})))
          }
          return v
        },[])
      },
      _prestacionesCheckSku_(){
        return this.rowItems
          .filter(ff=>ff.children)
          .reduce((v,c)=>({...v,[c.sku]:c.children.map(m=>m.folio).every(e=>this.prestacionesCheck[e])}),{})
      },
    },

    watch: {
      limit() {
        this.actualizarInfo()
      },
      items(newV,){
        this.loader = newV.reduce((v,c,i)=>({...v,[i]:false}),{})
        Object.keys(this.prestacionesCheck).forEach(key=>{
          if (!newV.find(f=>f.folio === Number(key))) {
            delete this.prestacionesCheck[key];
          }
        })
      },
      ubicacionRaiz: function() {
        this.page = 1;
        if (this.ubicacionRaiz == "") {
          this.items = [];
          return;
        }
        this.cambioUbicacionRaiz = true;
        this.actualizarInfo(true);
      },
      rowItems(newV,){
        const skus = newV.filter(ff=>ff.children).map(m=>m.sku)
        this.collapseItem = skus.reduce((v,c)=>({...v,[c]:(this.collapseItem[c]||false)}),{})
      }
    },

    methods: {

      validForm(){
        this.$v.$reset();
        this.$v.$touch();
        if(!this.$v.$invalid){
          this.actualizarInfo()
        }
      },
      checkSku(e,item){
          this.prestacionesCheck = item.children.reduce((v,c)=>{
            v[c.folio] = e.target.checked
            return v
          },{...this.prestacionesCheck})
      },
      checkAll(e){
          this.prestacionesCheck = this.items.reduce((v,c)=>{
            v[c.folio] = e.target.checked
            return v
          },{})
      },
      toggleHora() {
        this.showHora = !this.showHora;
      },
      toggleCreatedAt() {
        this.showCratedAt = !this.showCratedAt;
      },
      toggleAdvanceFilter() {
        this.advanceFilter = !this.advanceFilter;
      },
      getHour(date) {
        if(date === undefined || date === '') {
          return 'N/A';
        }
        let newDate = moment(date);
        return newDate.format("HH:mm:ss");
      },

      toggleAgrupar() {
        debugger
        this.agrupar = !this.agrupar;
      },
      getReporte(index, item) {
        if (this.loader[index]) {
          return;
        }
        this.loader[index] = true;
        this.$forceUpdate();
        const reportCall = {
          reporte: "formato_prestaciones",
          params: { folio: item.folio, ubicaciones: [this.ubicacionRaiz] },
          pdf: true
        };

        // console.log(reportCall);
        // call.push(reportCall);

        this.$store
          .dispatch("reportsPDFHttp", {
            ...reportCall
          })
          .then(res => {
            const blob = res;

            let a = document.createElement("a");
            a.style = "display: none";
            const url = window.URL.createObjectURL(blob);
            a.href = url;
            a.download = "Reporte de prestaciones.pdf";
            a.click();
            window.URL.revokeObjectURL(url);
          })
          .catch(rej => {
            // console.log(rej);
            this.error = rej.message;
            this.warningModal = true;
          })

          .finally(() => {
            this.loader[index] = false;
            this.$forceUpdate();
          });
      },
      validarTrabajador(trabajador) {
        if (trabajador._relaciones.trabajador != null) {
          return trabajador._relaciones.trabajador.payload.nombre;
        }
        // else{
        //   const trabajadorActual = this.trabajadores.filter(
        //     trabajador => trabajador.id == trabajador.trabajador_id
        //   );
        //   if (trabajadorActual.length > 0) {
        //     // return trabajadorActual[0].payload.nombre;
        //     return trabajadorActual[0].label
        //   } else {
        //     return "";
        //   }
        // }
      },
      validarActividad(actividad) {
        if (actividad._relaciones.actividad != null) {
          return actividad._relaciones.actividad.payload.nombre;
        }
      },
      validarUbicaciones(ubicaciones) {
        if (ubicaciones._relaciones.ubicacion != null) {
          var ubicacionesAll = "";
          Object.values(ubicaciones._relaciones.ubicacion).forEach(ubicacion => {
            ubicacionesAll += ubicacion.payload.nombre + ", ";
          });
          return ubicacionesAll;
        }
      },
      closeDropdown() {
        this.dropdownCustom = false;
      },
      searchTimeOut() {
        if (this.isCreated) {
          this.showTablePagosDias = false;
          if (this.timer) {
            clearTimeout(this.timer);
            this.timer = null;
          }
          this.timer = setTimeout(() => {
            this.actualizarInfo();
          }, 800);
        }
      },
      toggleUbicaciones() {
        this.showUbicaciones = !this.showUbicaciones;
      },
      toggleShowCancel() {
        this.showCancel = !this.showCancel;
        this.actualizarInfo();
      },
      sortField(field, direction, join) {
        if (join) {
          this.actualSort = "";
          this.sorting = "";
          this.actualSortJoin = field;
          this.sortingJoin = direction;
        } else {
          this.actualSort = field;
          this.sorting = direction;
          this.actualSortJoin = "";
          this.sortingJoin = "";
        }
        this.actualizarInfo();
      },
      dateSelection() {
        if(this.advanceFilter){
          return
        }
        if (this.isCreated) {
          if (this.timer) {
            clearTimeout(this.timer);
            this.timer = null;
          }
          this.timer = setTimeout(() => {
            this.actualizarInfo();
          }, 800);
        }
      },
      getDate(date) {
        if(date === undefined || date === '') {
          return 'N/A';
        }
        let newDate = moment(date,"YYYY-MM-DD 00:00:00");
        return newDate.format("DD/MM/YYYY");
      },
      getFullDate(date) {
        if(date === undefined || date === '') {
          return 'N/A';
        }
        let newDate = moment(date);
        return newDate.format("DD/MM/YYYY HH:mm:ss");
      },
      toggleEdit(index, item) {
        this.modal = true;
        const itemIndex = {
          id: index,
          name: item.cultivo
        };
        this.itemModal = itemIndex;
      },

      actualizarInfo(flagCombos = false){
        this.$v.$reset();
        if (this.ubicacionRaiz == "") {
          this.items = [];
          return;
        }

        const ubicacionesIds = this.filter?this.ubicaciones.filter(ff=>ff.payload.nombre.toUpperCase().includes(this.filter.toUpperCase())).map(m=>m.id):[]
        this.isLoading = true;
        let template = {
          schema: "prestaciones",
          limit: this.limit,
          page: this.page,
          filter: {
            wherein: [
              {
                field: "doc_prestaciones.payload->encabezado->ubicacion_raiz_id",
                value: [this.ubicacionRaiz]
              }
            ],
            where: [
              {
                field: "doc_prestaciones.payload->encabezado->fechahora",
                operator: ">=",
                value: moment(this.selectedDate.start).format(
                  "YYYY-MM-DD 00:00:00"
                )
              },
              {
                field: "doc_prestaciones.payload->encabezado->fechahora",
                operator: "<=",
                value: moment(this.selectedDate.end).format("YYYY-MM-DD 23:59:59")
              }
            ]
          },
          ["with-storage"]: ["*"]
        };

        this.actualSort != ""
          ? (template = {
              ...template,
              order: [
                {
                  field: this.actualSort,
                  direction: this.sorting
                }
              ]
            })
          : null;

        this.actualSortJoin != ""
          ? (template = {
              ...template,
              orderByJoin: [
                {
                  field: this.actualSortJoin,
                  direction: this.sortingJoin
                }
              ]
            })
          : null;


          !this.advanceFilter && this.filter != ""
          ? (template = {
              ...template,
              filter: {
                ...template.filter,
                and: {
                  orWhere: [
                    {
                      field: "doc_prestaciones.folio",
                      operator: "like",
                      value: `%${this.filter}%`,
                      collate: "utf8mb4_unicode_ci"
                    },
                    {
                      field: "doc_prestaciones.payload->encabezado->cantidad_costo",
                      operator: "like",
                      value: `%${this.filter}%`,
                      collate: "utf8mb4_unicode_ci"
                    },
                    {
                      field: "doc_prestaciones.payload->encabezado->costo_unitario",
                      operator: "like",
                      value: `%${this.filter}%`,
                      collate: "utf8mb4_unicode_ci"
                    },
                    ...ubicacionesIds.length&&this.showUbicaciones?[{
                      field: "doc_prestaciones.payload->encabezado->ubicaciones",
                      operator: "regexp",
                      value: `[[:<:]](${ubicacionesIds.join('|')})[[:>:]]`
                    }]:[],
                    ...(this.mostrarColumnaAutor
                      ? [
                          {
                            field: "doc_prestaciones.author->correo",
                            operator: "like",
                            value: `%${this.filter}%`,
                            collate: "utf8mb4_unicode_ci"
                          }
                        ]
                      : [])
                  ],
                  orWhereJoin: [
                    {
                      field: "trabajador.payload->nombre",
                      operator: "like",
                      value: `%${this.filter}%`,
                      collate: "utf8mb4_unicode_ci"
                    },
                    {
                      field: "actividad.payload->nombre",
                      operator: "like",
                      value: `%${this.filter}%`,
                      collate: "utf8mb4_unicode_ci"
                    }
                  ]
                }
              }
            })
          : null;

        !this.showCancel
          ? (template = {
              ...template,
              filter: {
                ...template.filter,
                where: [
                  ...template.filter.where,
                  {
                    field: "doc_prestaciones.estado",
                    operator: "!=",
                    value: "cancelado"
                  }
                ]
              }
            })
          : null;

        if(this.advanceFilter&&(this.query_filter.length>0)){
          template.filter.and = {
            ...this.query_filter.length?{where: this.query_filter}:{}
          }
        }

        const documento = [this.$store.dispatch("customDocumentoHTTP", template)];
        if (flagCombos || !this.isCreated || this.cambioUbicacionRaiz) {
          this.cambioUbicacionRaiz = false;
          this.isLoadingInfo = true;
          documento.push(
            this.$store.dispatch("customHTTP", { schema: "empresas" })
          );
          documento.push(
            this.$store.dispatch("customHTTP", {
              schema: "trabajadores",
              filter: {
                where: [
                  {
                    field: "payload->ubicaciones",
                    operator: "regexp",
                    value: `[[:<:]]${this.ubicacionRaiz}[[:>:]]`
                  },
                  {
                    field: "payload->suspendido",
                    operator: "=",
                    value: false
                  }
                ]
              }
            })
          );
          documento.push(
          this.$store.dispatch("customHTTP", {
            schema: "actividades",
          }))
        }

        Promise.all(documento)
          .then(([documentos, empresas, trabajadores, actividades]) => {
            this.items = documentos.data;
            this.pages = documentos?.paginate?.last_page;
            this.page = documentos?.paginate?.current_page;
            this.total = documentos?.paginate?.total||0

            if(empresas&&empresas.data.length>0){
              this.empresas = empresas.data.map(empresa => {
                return {
                  value: empresa.id,
                  label: empresa.payload.nombre
                };
              }).sort((a,b)=>a.label.localeCompare(b.label));
            }
            if(actividades&&actividades.data.length>0){
              this.actividades = actividades.data.map(actividad => {
                return { value: actividad.id, label: actividad.payload.nombre };
              }).sort((a,b)=>a.label.localeCompare(b.label));
              this.actividadesAll = actividades.data
            }
            if(trabajadores&&trabajadores.data.length>0){
              this.trabajadores = trabajadores.data.map(trabajador => {
                return {
                  value: trabajador.id,
                  label: trabajador.payload.nombre
                };
              }).sort((a,b)=>a.label.localeCompare(b.label));
            }

            this.isCreated = true;
          })
          .catch(error => {
            console.log(error.message);
          })
          .finally(() => {
            this.isLoading = false;
            this.isLoadingInfo = false;
          });
      },
      toggleCollapse(sku){
        this.collapseItem[sku] = !this.collapseItem[sku]
      }
    }
  };
  </script>

  <style src="spinkit/spinkit.min.css"></style>
  <style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

  <style>

    .footer-table{
      display: grid;
      grid-template-columns: 1fr 1fr 1fr;
    }
    .dropdown-menu{
      min-width: 14rem;
    }
    .advance-filter .multiselect__spinner{
      height: 30px;
    }
    .advance-filter .multiselect__placeholder{
      margin-bottom: 0px;
    }
    .advance-filter .multiselect__select{
      height: 34px;
    }
    .advance-filter .multiselect__tags{
        max-height: 35px;
        overflow: auto;
        min-height: unset;
        padding: 5px 40px 5px 5px;
    }
    .advance-filter .multiselect__content-wrapper{
        width: 100%;
    }
    .advance-filter .vs__dropdown-toggle{
        height: 35px;
    }
  </style>


  <style scoped>
  .loader-container {
    position: absolute;
    inset: 0;
    background: #ffffff99;
    z-index: 2;
    display: grid;
    place-content: center;
  }
  .loader-container .loader .lds-grid {
    display: inline-block;
    position: relative;
    width: 80px;
    height: 80px;
  }
  .loader-container .loader .lds-grid div {
    position: absolute;
    width: 16px;
    height: 16px;
    border-radius: 50%;
    background: #000;
    animation: lds-grid 1.2s linear infinite;
  }
  .loader-container .loader .lds-grid div:nth-child(1) {
    top: 8px;
    left: 8px;
    animation-delay: 0s;
  }
  .loader-container .loader .lds-grid div:nth-child(2) {
    top: 8px;
    left: 32px;
    animation-delay: -0.4s;
  }
  .loader-container .loader .lds-grid div:nth-child(3) {
    top: 8px;
    left: 56px;
    animation-delay: -0.8s;
  }
  .loader-container .loader .lds-grid div:nth-child(4) {
    top: 32px;
    left: 8px;
    animation-delay: -0.4s;
  }
  .loader-container .loader .lds-grid div:nth-child(5) {
    top: 32px;
    left: 32px;
    animation-delay: -0.8s;
  }
  .loader-container .loader .lds-grid div:nth-child(6) {
    top: 32px;
    left: 56px;
    animation-delay: -1.2s;
  }
  .loader-container .loader .lds-grid div:nth-child(7) {
    top: 56px;
    left: 8px;
    animation-delay: -0.8s;
  }
  .loader-container .loader .lds-grid div:nth-child(8) {
    top: 56px;
    left: 32px;
    animation-delay: -1.2s;
  }
  .loader-container .loader .lds-grid div:nth-child(9) {
    top: 56px;
    left: 56px;
    animation-delay: -1.6s;
  }
  @keyframes lds-grid {
    0%,
    100% {
      opacity: 1;
    }
    50% {
      opacity: 0.5;
    }
  }


  .line {
    width: 100%;
    color: #321fdb; /* old IE */
    background-color: #321fdb; /* Modern Browsers */
  }
  .z-custom {
    z-index: 1;
  }
  .z-custom-2 {
    z-index: 4;
  }
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.5s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
  .catalogo-text {
    font-size: 1.2rem !important;
  }

  .custom-width-btn {
    width: 40%;
  }
  .custom-heigth-btn {
    width: 100%;
  }
  .custom-font-size {
    font-size: 1rem;
  }
  @media (max-width: 420px) {
    .btn-header {
      padding-left: 6px;
      padding-right: 6px;
      font-size: 11px;
    }
    .padding-sm {
      padding-left: 10px;
      padding-right: 10px;
    }
    .text-sm {
      font-size: 11px !important;
    }
    .margin-sm {
      margin: 5px;
    }
    .pointer{
      cursor: pointer;
    }

  }
  </style>
  <style>
    .modal-content-info .modal-dialo {
      max-width: 700px;
    }
  </style>
